/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React, {useState} from "react";
import {Story} from "../../types/story";
import Stories from "react-insta-stories";

function AppStories({stories, storyOpeners, extraClass}: Story) {
    const [isStoryViewerOpen, setIsStoryViewerOpen] = useState(false);
    const [currentStoryIndex, setCurrentStoryIndex] = useState(0);

    const handleOpenStory = (index:number) => {
        setCurrentStoryIndex(index);
        setIsStoryViewerOpen(true);
        const headerElement = document.querySelector('header');
        if (headerElement) {
            headerElement.style.display = 'none';
            // @ts-ignore
            document.querySelector('body').style.overflow = 'hidden';
        }
    };

    const handleCloseStoryViewer = () => {
        setIsStoryViewerOpen(false);
        const headerElement = document.querySelector('header');
        if (headerElement) {
            headerElement.style.display = '';
            // @ts-ignore
            document.querySelector('body').style.overflow = 'scroll';
        }
    };

    return (
        <div>
            <div className="flex justify-start gap-4">
                {storyOpeners.map((opener, index) => (
                    <div
                        className={`p-1 mb-2 bg-[#EBE6DE] mt-2 border-[0.5px] border-black rounded-full cursor-pointer hover:scale-105 transition-transform ease-in-out duration-300 ${extraClass}`}
                        key={index} onClick={() => handleOpenStory(index)}>
                        <div
                            className="w-20 h-20 p-2 rounded-full bg-cover bg-center border-2 border-white"
                            style={{
                                backgroundImage: `url(${opener.thumbnail})`,
                            }}
                            title={opener.label}
                        ></div>
                    </div>
                ))}
            </div>

            {isStoryViewerOpen && (
                <div
                    className={`fixed top-0 left-0 w-full h-screen bg-[#111111] flex items-center justify-center z-9999`}>
                    <button
                        onClick={() => handleCloseStoryViewer()}
                        className="absolute top-3 right-4 text-white text-3xl focus:outline-hidden z-9999"
                    >
                        ✕
                    </button>
                    <Stories
                        storyContainerStyles={{width: "100%", height: "100%"}}
                        stories={stories}
                        height={'100vh'}
                        defaultInterval={5000}
                        currentIndex={currentStoryIndex}
                        onAllStoriesEnd={handleCloseStoryViewer}
                    />
                </div>
            )}
        </div>
    );
}

export default AppStories;